import React from 'react';
import { FooterContainer } from './cssStyles';


const Footer = () => {
  return <FooterContainer>&copy; 2024 Yokowerx</FooterContainer>;
};

export default Footer;